// extracted by mini-css-extract-plugin
export default {"component":"TooltipContentReceptionist_component__nWeyf"};